import { Button } from 'antd'
import * as React from 'react'
import TextField from 'ui/molecules/TextField'

import { FormBuilderContext } from '../../../pages/Contexts/FormBuilderContext'

function BuilderSideMenuEditPage() {
  const { selectedItem, setPage, deletePage, getPage } =
    React.useContext(FormBuilderContext)

  const page = getPage(selectedItem.id)

  const onChangePageTitle = React.useCallback(
    (nextTitle) => {
      setPage(selectedItem.id, {
        ...page,
        title: nextTitle,
      })
    },
    [page, selectedItem, setPage]
  )

  return (
    <div className="space-y-4 pb-1">
      <TextField
        label="Section title"
        name="page-title"
        onChange={onChangePageTitle}
        placeholder="Section title"
        value={page?.title ?? ''}
      />
      {Boolean(page?.repeat_section) ? (
        <Button
          danger
          className="w-full"
          onClick={() => deletePage(page.id)}
          type="primary"
        >
          Delete Section
        </Button>
      ) : null}
    </div>
  )
}

export default BuilderSideMenuEditPage
